if (!customElements.get("card-variants")) {
  customElements.define(
    "card-variants",
    class CardVariants extends HTMLElement {
      constructor() {
        super();

        this.parent = this.parentNode;

        this.variantMediaWrappers =
          this.parent.querySelectorAll("[data-variant-alt]");
        this.radio = this.querySelectorAll('[type="radio"]');

        this.handleRadioChange = this.onRadioChange.bind(this);

        Array.from(this.radio).forEach((input) =>
          input.addEventListener("change", this.handleRadioChange)
        );
      }

      onRadioChange(event) {
        if (event.currentTarget.checked) {
          // const name = event.currentTarget.name;
          const value = event.currentTarget.value;
          const valueId = event.currentTarget.dataset.value;

          this,
            Array.from(this.variantMediaWrappers).forEach((mediaWrapper) => {
              if (
                (mediaWrapper.dataset.variantAlt.includes(":") &&
                  !mediaWrapper.dataset.variantAlt
                    .split(":")
                    .includes(value)) ||
                (mediaWrapper.dataset.variantAlt.includes("_") &&
                  !mediaWrapper.dataset.variantAlt.split("_").includes(valueId))
              ) {
                mediaWrapper.style.setProperty("display", "none", "important");
              } else {
                mediaWrapper.style.setProperty("display", "");
              }
            });
        }
      }

      handleizeString(str) {
        if (str) {
          return str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
        }
        return "";
      }
    }
  );
}
